import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateLibraryComponent } from './template-library.component';
import { CoreModule } from '../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogService } from '../core/services/dialog.service';

@NgModule({
  declarations: [TemplateLibraryComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CoreModule],
  providers: [],
})
export class TemplateLibraryModule {}
